module.exports = __webpack_public_path__ + "static/image-accounts-hero-09d5cfb1e6af19900af11e85f8bf4bcc.png";